import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const SALES_ENDPOINT = process.env.REACT_APP_SALES_ENDPOINT;
const TOKEN_KEY = process.env.REACT_APP_TOKEN_KEY;

// Create axios instance
const api = axios.create({
  baseURL: API_URL
});

// Add request interceptor to attach the token to all requests
api.interceptors.request.use(config => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Get all sales
export const getAllSales = async () => {
  try {
    const response = await api.get(`${SALES_ENDPOINT}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching sales:', error);
    throw error;
  }
};

// Get a single sale by ID
export const getSaleById = async (saleId) => {
  try {
    const response = await api.get(`${SALES_ENDPOINT}/${saleId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching sale ${saleId}:`, error);
    throw error;
  }
};

// Get sales by date range
export const getSalesByDateRange = async (startDate, endDate) => {
  try {
    const response = await api.get(`${SALES_ENDPOINT}/by-date`, {
      params: { startDate, endDate }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching sales by date range:', error);
    throw error;
  }
};

// Create a new sale
export const createSale = async (saleData) => {
  try {
    const response = await api.post(`${SALES_ENDPOINT}`, saleData);
    return response.data;
  } catch (error) {
    console.error('Error creating sale:', error);
    throw error;
  }
};

// Update an existing sale
export const updateSale = async (saleId, saleData) => {
  try {
    const response = await api.put(`${SALES_ENDPOINT}/${saleId}`, saleData);
    return response.data;
  } catch (error) {
    console.error(`Error updating sale ${saleId}:`, error);
    throw error;
  }
};

// Delete a sale
export const deleteSale = async (saleId) => {
  try {
    const response = await api.delete(`${SALES_ENDPOINT}/${saleId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting sale ${saleId}:`, error);
    throw error;
  }
};

// Get profit report
export const getProfitReport = async (startDate, endDate, valuationMethod = 'fifo') => {
  try {
    const response = await api.get('/sales/profit', {
      params: {
        startDate,
        endDate,
        valuationMethod
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching profit report:', error);
    throw error;
  }
}; 